module.exports = __webpack_public_path__ + "img/security-and-navigation-right-disabled.986b4911.svg";